// Role helpers for the frontend.
// Roles: 'user' < 'admin' < 'owner'.
// Owner is a superset of admin (full founder access).

export const isOwner = (user) => user?.role === 'owner';

export const isAdmin = (user) => user?.role === 'admin' || user?.role === 'owner';

export const canManageUsers = (user) => isOwner(user);

export const canManageTemplates = (user) => isAdmin(user);
